/* eslint-disable @typescript-eslint/no-explicit-any */
import useCreateClientInvitation from '@/hooks/mutate/useCreateClientInvitation'
import { useGetSafeClientCode } from '@/hooks/router'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Button } from '@/components/button'
import { DialogFooter } from '@/components/dialog'
import { Form } from '@/components/form'
import FormInput from '@/components/form/formInput'
import { toast } from '@/components/toast/useToast.ts'

interface Props {
    onSuccess: () => void
}

export default function InviteSomeone({ onSuccess }: Props) {
    const clientCode = useGetSafeClientCode()

    const { onCreate, isPending } = useCreateClientInvitation(clientCode, () => {
        toast({
            title: 'Successfully created invitation',
        })
        onSuccess()
    })

    const formSchema = z.object({
        inviteEmail: z.string().email(),
    })

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        mode: 'onBlur',
    })

    const onSubmit = (values: z.infer<typeof formSchema>) => {
        onCreate({
            email: values.inviteEmail,
        })
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 pt-4">
                <FormInput control={form.control} name="inviteEmail" label={<>Email Address</>} />

                <DialogFooter>
                    <Button type="submit" disabled={!form.formState.isValid || isPending}>
                        {isPending ? 'Inviting' : 'Invite'}
                    </Button>
                </DialogFooter>
            </form>
        </Form>
    )
}
